module.exports = __webpack_public_path__ + "media/images/ui__textArrowRightLight-6ac1ea4b84cdd08528defa6508b9e90c.png";